<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Bank">
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px">
            </a-col>
            <a-col flex="0 1 300px">
                <a-button type="primary" icon="plus" block @click="showModal('')">
                Tambah
                </a-button>
            </a-col>
        </a-row>

        <a-card type="inner" size="small" >
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="items.data"
                rowKey="hash"
                :pagination="false"
                :loading="loading"
                bordered>

                <div slot="name" slot-scope="record" class="text-small text-left">
                    {{ record.name }}
                </div>

                <div slot="code" slot-scope="record" class="text-small text-left">
                    {{ record.code }}
                </div>

                <div slot="contact" slot-scope="record" class="text-small text-left">
                    <a-row type="flex" v-if="record.phone != null" style="margin-bottom:10px">
                        <a-col :span="2"><a-icon type="mobile"/></a-col>
                        <a-col>{{ record.phone }}</a-col>
                    </a-row>
                    <a-row type="flex" v-if="record.address != null">
                        <a-col :span="2"><a-icon type="idcard" /></a-col>
                        <a-col>{{ record.address }}</a-col>
                    </a-row>
                </div>

                <div slot="pic_name" slot-scope="record" class="text-small text-left">
                    {{ record.pic_name }}
                </div>

                <div slot="pic_contact" slot-scope="record" class="text-small text-left">
                    {{ record.pic_contact }}
                </div>

                <div slot="status" slot-scope="record">
                    <a-tag
                        :color="record.is_active == true ? 'green' : 'red'"
                    >
                        {{
                            record.is_active == true
                                ? "active"
                                : "not active"
                        }}
                    </a-tag>
                </div>

                <div slot="updated_at" slot-scope="record" class="text-small text-center">
                    <template v-if="record.updated_at != null">
                        {{ moment(record.updated_at).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </div>

                <div slot="action" slot-scope="record" style="text-align: center">
                    <a-space>
                        <a-tooltip title="Detail">
                            <a-button size="small" icon="eye" :href="routeUri('admin.setting.branch') + '?id=' + record.hash" />
                        </a-tooltip>

                        <a-tooltip title="Edit">
                            <a-button size="small" type="primary" icon="edit" @click="showModal(record.hash)" />
                        </a-tooltip>
                    </a-space>
                </div>
            </a-table>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false"
        >
            <admin-setting-bank-form
                :hash="hash"
                @handleClose="closeModal"
            />
        </a-modal>
    </div>
</template>

<script>

const columns = [
    {
		key: 'name',
		title: 'Bank',
        align: 'center',
		scopedSlots: {customRender: 'name'},
	}, {
		key: 'code',
		title: 'Kode',
        align: 'center',
        width: '150px',
		scopedSlots: {customRender: 'code'}
	}, {
        key: 'contact',
        title: 'Kontak',
        align: 'center',
        scopedSlots: {customRender: 'contact'},
    }, {
        key: 'pic_name',
        title: 'Nama PIC',
        align: 'center',
        scopedSlots: {customRender: 'pic_name'},
    }, {
        key: 'pic_contact',
        title: 'Kontak PIC',
        align: 'center',
        scopedSlots: {customRender: 'pic_contact'},
    },{
		key: 'status',
		title: 'Status',
        align: 'center',
		scopedSlots: {customRender: 'status'}
	}, {
        key: 'updated_at',
        title: 'Last Update',
        align: 'center',
        width: '180px',
        scopedSlots: {customRender: 'updated_at'}
    }, {
		key: 'action',
		title: 'Action',
		align: 'center',
		scopedSlots: {customRender: 'action'}
	}
]

export default {
    data() {
        return {
            columns,
            loading: false,
            items: {
                data: []
            },
            filters: {
                q: null
            },
            hash: null,
            visible: false,
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri('api.banks'), {
                    params: this.filters
                })
                .then(response => this.items = response.data.banks)
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        showModal(hash) {
            this.hash = hash;
            this.visible = true;
        },
        closeModal(isRefresh) {
            this.visible = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
    },
}
</script>
